import { Attribute } from "@/components/atoms";
import { UserCredential, UserHealthcareDomain } from "@/types/user";
import { UserEducation } from "@/types/user/user.types";

interface LabeledListProps {
  label: string;
  items:
    | UserCredential["credential"]["credential_name"][]
    | UserHealthcareDomain["healthcare_domain"]["value"][]
    | UserEducation["education"]["education_name"][]
    | null
    | undefined;
}

export const LabeledList = ({ label, items }: LabeledListProps) => {
  const displayItems = items && items.length > 0 ? items : ["None selected"];

  return (
    <Attribute
      componentName={`labeled-list-${label.toLowerCase().replace(/\s+/g, "-")}`}
      label={label}
      value={displayItems}
    />
  );
};
